export const HubConstants = {
    START_EDITING_DELIVERY_RESOURCE: "StartEditingDeliveryResource",
    STOP_EDITING_DELIVERY_RESOURCE: "StopEditingDeliveryResource",
    DELIVERY_RESOURCE_ALREADY_BEING_EDITED_PREFIX: "ReceiveDeliveryResourceAlreadyBeingEdited",
    DELIVERY_RESOURCE_EDIT_STATUS_CHANGE_PREFIX: "ReceiveDeliveryResourceEditStatusChange",
    CREATE_PREFIX: "ReceiveCreate",
    UPDATE_PREFIX: "ReceiveUpdate",
    DELETE_PREFIX: "ReceiveDelete",
    HIGHLIGHTS_GROUPS_RESOURCE_NAME_PREFIX: "HighlightsGroups",
    HIGHLIGHTS_GROUP_RESOURCE_NAME_PREFIX: "HighlightsGroup",
    SIDE_NOTE_RESOURCE_NAME_PREFIX: "SideNote",
    HIGHLIGHT_RESOURCE_NAME_PREFIX: "Highlight",
    TECHNOLOGY_NAME_RESOURCE_NAME_PREFIX: "TechnologyName",
    TECHNOLOGY_DESCRIPTION_RESOURCE_NAME_PREFIX: "TechnologyDescription",
    ADDITIONAL_TECHNOLOGIES_RESOURCE_NAME_PREFIX: "AdditionalTechnologies",
    TECHNOLOGY_VOTES_RESOURCE_NAME_PREFIX: "TechnologyVotes",
    TECHNOLOGY_RATES_RESOURCE_NAME_PREFIX: "TechnologyRates",
    TECHNOLOGY_REQUIREMENT_SCORE_RESOURCE_NAME_PREFIX: "TechnologyRequirementScore",
    NOTIFICATION_MESSAGE_PREFIX: "ReceiveNotificationMessage"
} as const;